import './footer-modal.component.scoped.scss'

interface Props {
  getConfirmElement: () => JSX.Element
  getCancelElement: () => JSX.Element
}

export default ({ getConfirmElement, getCancelElement }: Props) => {
  return (
    <footer className="footer-modal display-flex mb-2">
      {getConfirmElement()}
      {getCancelElement()}
    </footer>
  )
}
